import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const MlsProviderFileProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `File/${props.fileId}`, method: 'GET', secure: true });
    }, [execute]);

    const newRecord = useCallback(async (props) => {
        await execute({ scope: 'new', payload: { status: 200, body: props } });
    }, [execute]);

    const createRecord = useCallback(async (props) => {       
        await execute({ scope: 'create', url: `File/MlsProvider/${props.mlsProviderId}`, method: 'POST', payload: props, multipart: true, secure: true });
    }, [execute]);

    const listRecords = useCallback(async (props) => {
        await execute({ scope: 'list', url: `File/MlsProvider/${props.mlsProviderId}`, method: 'GET', secure: true });
    }, [execute]);

    const deleteRecord = useCallback(async (props) => {
        await execute({ scope: 'delete', url: `File/MlsProvider/${props.mlsProviderId}/${props.fileId}`, method: 'DELETE', secure: true });
    }, [execute]);

    const value = { selectRecord, newRecord, createRecord, listRecords, deleteRecord, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useMlsProviderFileStore = () => React.useContext(Context);
